// Thin analytics wrapper. Loads GA4 + Klaviyo only if measurement IDs are
// present. Exposes a tiny event surface (track, identify, page) so feature
// code never reaches into window.gtag / window._learnq directly.

let initialized = false;

export function initAnalytics(config) {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  if (config.ga.measurementId) {
    const id = config.ga.measurementId;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
  }

  if (config.klaviyo.siteId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${config.klaviyo.siteId}`;
    document.head.appendChild(s);
    window._learnq = window._learnq || [];
  }
}

export function page(path, title) {
  if (typeof window === "undefined") return;
  if (window.gtag) {
    window.gtag("event", "page_view", { page_path: path, page_title: title });
  }
  if (window._learnq) {
    window._learnq.push(["track", "Viewed Page", { url: path, title }]);
  }
}

export function track(event, props = {}) {
  if (typeof window === "undefined") return;
  if (window.gtag) window.gtag("event", event, props);
  if (window._learnq) window._learnq.push(["track", event, props]);
}

export function identify(user) {
  if (typeof window === "undefined" || !user) return;
  if (window.gtag) window.gtag("set", "user_properties", { user_id: user.id });
  if (window._learnq) {
    window._learnq.push(["identify", {
      $email: user.email,
      $first_name: user.firstName,
      $last_name: user.lastName,
      company: user.company,
    }]);
  }
}
